import { render, staticRenderFns } from "./CenterNavbar.vue?vue&type=template&id=fb3ccb9e&"
import script from "./CenterNavbar.vue?vue&type=script&lang=js&"
export * from "./CenterNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports